export default {
  methods: {
    getImageOrientation(image) {
      if (typeof image === 'string') return image;
      if (this.$mq === 'sm' || this.$mq === 'xsm') return image.mobile;
      return image.desktop;
    }
  }
};
